module.exports = __webpack_public_path__ + "static/media/bone1.131edcb4.png";